import * as React from 'react';

import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldState } from 'informed';
import { inputClasses } from '../validation/ValidationClasses';
import { TextArea } from './TextArea';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { useReferenceContextProvider } from '../../Core/ReferenceContextProvider';

interface ConfigFieldTextAreaProps {
    id: string;
    field: string;
    className: string;
    disabled?: boolean;
    hidden?: boolean;
    validated: boolean;
    required?: boolean;
    itemId: ConfigurableDataItemIds;
    isInputAddon?: boolean;
    inputAddon?: React.ReactNode;
    type?: string;
    autoComplete?: string;
    onBlur?: any;
}

export const ConfigFieldTextArea = (props: ConfigFieldTextAreaProps): JSX.Element => {
    const {
        id,
        field,
        className,
        disabled,
        hidden,
        validated,
        required,
        itemId,
        isInputAddon,
        inputAddon,
        type,
        autoComplete,
        onBlur
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const { unitTypes } = useReferenceContextProvider();

    const fieldState = useFieldState(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className} hidden={hidden} data-automationid={`${id}-form-group`}>
                <label htmlFor={id}>{item.displayText}</label>
                    <TextArea
                        id={id}
                        field={field}
                        className={inputClasses(fieldState.error)}
                        validate={ConfigFieldValidation(item, required, validated)}
                        disabled={disabled}
                        type={type}
                        autoComplete={autoComplete}
                        onBlur={onBlur}
                        inputAddon={isInputAddon && inputAddon === undefined ? unitTypes.find(ut => ut.id === item.unitTypeId)?.name : inputAddon}
            />
            </div>
        </Condition>
    </>
}
